import { forNamespace } from 'app/common/lib/util/i18n';
import { SuggestionsFeedback } from 'app/src/components/SuggestionsFeedback';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import React from 'react';

const viewTitle = forNamespace('view title');

export function getFeedback(context: string) {
  return (e: Event) => {
    e.stopPropagation();
    e.preventDefault();

    const popoverOptions = {
      elem: e.currentTarget,
      getViewTitle: () => viewTitle('feedback'),
      reactElement: (
        <SuggestionsFeedback
          key="suggestions-feedback"
          context={context}
          onClose={() => PopOver.popView()}
        />
      ),
    };

    if (PopOver.contains(e.currentTarget)) {
      PopOver.pushView(popoverOptions);
    } else {
      PopOver.toggle(popoverOptions);
    }
  };
}
